import { Route, Routes } from 'react-router-dom'
import Home from './components/Home/Home'
import About from './components/About/About'
import Goal from './components/Goal/Goal'
import Actuality from './components/Actuality/Actuality'
import Contact from './components/Contact/Contact'
import Admin from './components/Admin/Admin'
import Donation from './components/Donation/Donation'
import ActualityDetail from './components/Actuality/ActualityDetail'
import AdminSignIn from './components/Admin/AdminSignIn'
import CGU from './components/CGU/CGU'

function Router({ ip }) {

    return (

        <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/donation" element={<Donation ip={ip} />} />
            <Route path="/à-propos" element={<About />} />
            <Route path="/à-propos/:type" element={<About />} />
            <Route path="/objectifs" element={<Goal />} />
            <Route path="/objectifs/:type" element={<Goal />} />
            <Route path="/actualités" element={<Actuality />} />
            <Route path="/actualités/:id" element={<ActualityDetail />} />
            <Route path="/contactez-nous" element={<Contact ip={ip} />} />
            <Route path="/CGU" element={<CGU />} />

            <Route path="/administration" element={<Admin ip={ip} />} />
            <Route path="/administration/connexion" element={<AdminSignIn ip={ip} />} />
        </Routes>

    )

}

export default Router
